<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-copyright element-without-heading" epub:type="copyright-page" id="copyright">
<div class="text" id="copyright-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content"><b><span class="smallcaps">Monsters, Movies &amp; Mayhem</span></b></p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Copyright © 2020 WordFire Press</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Individual Copyright Information Available at End of Book</p>
</div>
</div>
<p class="first first-in-chapter first-full-width copyright-content">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any electronic or mechanical means, including photocopying, recording or by any information storage and retrieval system, without the express written permission of the copyright holder, except where permitted by law. This novel is a work of fiction. Names, characters, places and incidents are either the product of the author’s imagination, or, if real, used fictitiously.</p>
<p class="subsq copyright-content">The ebook edition of this book is licensed for your personal enjoyment only. The ebook may not be re-sold or given away to other people. If you would like to share the ebook edition with another person, please purchase an additional copy for each recipient. Thank you for respecting the hard work of this author.</p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">EBook ISBN: 978-1-68057-106-6</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Trade Paperback ISBN: 978-1-68057-105-9</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Hardcover ISBN: 978-1-68057-107-3</p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Kevin J. Anderson, Executive Editor</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Editorial Team: Kelly Lynn Colby, Elizbeth Drisko, Angela Johnson, Ashley King, Scott Lee, Tracy Leonard Nakatani, James Romag, Kailey Urbaniak, and Carol Wyrick</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">This anthology was made possible with assistance from Draft2Digital and Western Colorado University</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Kevin J. Anderson, Art Director</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Published by</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press, LLC</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">PO Box 1840</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Monument CO 80132</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Kevin J. Anderson &amp; Rebecca Moesta, Publishers</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press eBook Edition 2020</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press Trade Paperback Edition 2020</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press Hardcover Edition 2020</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Printed in the USA</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Join our WordFire Press Readers Group for</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">sneak previews, updates, new projects, and giveaways.</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Sign up at <a class="content-external-link text-is-url" href="http://wordfirepress.com" target="_blank">wordfirepress.com</a></p>
</div>
</div>
<p class="created-with-vellum"><a href="http://tryvellum.com/created" target="_blank"><span class="created-with-vellum-image-decorator"><span class="created-with-vellum-image-size-container"><img alt="Vellum flower icon" class="created-with-vellum-image" src="images/vellum-created.svg"/></span></span> <span class="created-with-vellum-text">Created with Vellum</span></a></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7e97bc98